import DetailWebView from './webview';
import GameWebView from './game-webview';
import WebViewInner from './webview-inner';
export {GameWebView, WebViewInner};

export default DetailWebView;
